module.exports = __webpack_public_path__ + "images/spinner-64-7aa386c6e23208ccb068a06cce5287eb.gif";